export function validateIsGSTIN(value) {
  const pattern =
    /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Za-z]{1}[Z]{1}[0-9A-Z]{1}$/;
  return pattern.test(value);
}


export function validateIsPAN(value) {
  const pattern = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
  return pattern.test(value);
}

export function validatePersonalPAN(value) {
  const pattern = /^[A-Z]{3}P[A-Z][0-9]{4}[A-Z]$/;
  return pattern.test(value);
}

export function validateIsMobileNumber(value) {
  const pattern = /^\d{10}$/;
  return pattern.test(value);
}

export function validateIsEmailAddress(value) {
  const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return pattern.test(value);
}
export function validateIsAlphaNumeric(value) {
  const pattern = /^[a-zA-Z0-9]+$/;
  return pattern.test(value);
}

export function validateIfscCode(value) {
  const pattern = /^[A-Z]{4}0[A-Z0-9]{6}$/;
  return pattern.test(value);
}

export function validateAccountNumber(value) {
  const pattern = /^[0-9]{9,18}$/;
  return pattern.test(value);
}
// Allow only alphabetic characters (a-z, A-Z)
export const alphabeticRegex = /^[a-zA-Z]*$/;

// Image Compression Utilities
export * from './imageCompression';
export * from './AgeCalc';
